import React from "react";
import { Link } from "react-router-dom";

// Background image
import serviceBg from "../../images/bg/service-gradient-bg.png";

// Service images
import img01 from "../../images/main/ai_autoamtion.png";
import img02 from "../../images/main/ai_product.png";
import img03 from "../../images/main/webapp.png";
import img04 from "../../images/main/ecomm.png";
import img05 from "../../images/main/cloud.png";
import img06 from "../../images/main/erp.png";

const ServiceSection: React.FC = () => {
  // ========================
  // ICON SVG
  // ========================
  const arrowIcon = (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="6.29004"
        y="21.4111"
        width="22.36"
        height="2.83936"
        transform="rotate(-40.2798 6.29004 21.4111)"
        fill="white"
      />
      <rect
        x="9.44824"
        y="7.57031"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 9.44824 7.57031)"
        fill="white"
      />
      <rect
        x="13.4492"
        y="7.90015"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 13.4492 7.90015)"
        fill="white"
      />
      <rect
        x="17.4512"
        y="8.23047"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 17.4512 8.23047)"
        fill="white"
      />
      <rect
        x="21.123"
        y="12.5627"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 21.123 12.5627)"
        fill="white"
      />
      <rect
        x="20.793"
        y="16.5649"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 20.793 16.5649)"
        fill="white"
      />
      <rect
        x="20.4619"
        y="20.5669"
        width="2.83936"
        height="2.83936"
        transform="rotate(-40.2798 20.4619 20.5669)"
        fill="white"
      />
    </svg>
  );

  // ========================
  // ARRAY DATA
  // ========================
  const services = [
    {
      title: "AI Agents",
      content:
        "Develop and deploy autonomous AI agents designed to handle complex multi-step workflows, automate decision-making, and interact intelligently with your existing systems.",
      images: [img01, img01, img01, img01],
      link: "/services/ai-agents",
    },
    {
      title: "AI Product Engineering",
      content:
        "Transform conceptual ideas into production-ready AI solutions, handling everything from custom model training to seamless API integration and scalable architecture.",
      images: [img02, img02, img02, img02],
      link: "/services/generative-ai",
    },
    {
      title: "Intelligent Web Apps",
      content:
        "Develop high-performance web platforms integrated with NLP-driven chatbots and virtual assistants to automate user engagement and provide 24/7 intelligent support.",
      images: [img03, img03, img03, img03],
      link: "/services/web-portal-development",
    },
    {
      title: "Smart E-commerce",
      content:
        "Optimize digital storefronts using AI-powered recommendation engines, dynamic pricing algorithms, and real-time consumer behavior analytics.",
      images: [img04, img04, img04, img04],
      link: "/services/ecommerce-website",
    },
    {
      title: "Cloud Infra & AI Strategy",
      content:
        "Accelerate digital transformation by migrating legacy workflows to AI-optimized cloud environments, ensuring high availability and enterprise-grade security.",
      images: [img05, img05, img05, img05],
      link: "/services/cloud-migration",
    },
    {
      title: "Cognitive ERP & Business Logic",
      content:
        "Modernize enterprise resource planning with automated data entry, intelligent forecasting, and AI-assisted workflow optimization to eliminate operational silos.",
      images: [img06, img06, img06, img06],
      link: "/solutions/crm",
    },
  ];

  // ========================
  // RETURN SECTION
  // ========================
  return (
    <section
      className="service pos-rel bg_img"
      style={{ backgroundImage: `url(${serviceBg})` }}
    >
      <div className="container">
        <div className="row mt-none-30">
          {services.map((service, index) => (
            <div className="col-lg-6 mt-30" key={index}>
              <div className="xb-ser-item xb-border img-hove-effect">
                <div className="xb-item--inner">
                  <h3 className="xb-item--title border-effect">
                    <Link to={service.link}>{service.title}</Link>
                  </h3>

                  <Link className="xb-item--icon" to={service.link}>
                    {arrowIcon}
                  </Link>

                  <p className="xb-item--content">{service.content}</p>

                  <div className="xb-item--img xb-img">
                    {service.images.map((img, i) => (
                      <Link key={i} to={service.link}>
                        <img src={img} alt="service" />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
